import { backendClient } from "@/lib/backend-api";
import { safe } from "@orpc/client";

export const getOnboarding = async () => {
  const result = await safe(backendClient.onboarding.start());

  return result.data;
};

export const getOnboardingStatus = async () => {
  const result = await safe(backendClient.onboarding.getStatus());

  return result.data;
};

export const markDemoMeetingOpened = async () => {
  const result = await safe(backendClient.onboarding.markDemoMeetingOpened());

  if (!result.isSuccess) {
    throw result.error;
  }

  return result.data;
};

export const markDemoDateChosen = async () => {
  const result = await safe(backendClient.onboarding.markDemoDateChosen());

  if (!result.isSuccess) {
    throw result.error;
  }

  return result.data;
};

export const subscribeToOnboardingStream = async (signal?: AbortSignal) => {
  const result = await safe(
    backendClient.onboarding.stream({
      context: signal ? { signal } : undefined,
    }),
  );

  if (!result.isSuccess) {
    console.error("Failed to subscribe to onboarding stream:", result.error);
    return null;
  }

  return result.data;
};
